import { render, staticRenderFns } from "./DecisionList.vue?vue&type=template&id=73e27873&scoped=true"
import script from "./DecisionList.vue?vue&type=script&lang=js"
export * from "./DecisionList.vue?vue&type=script&lang=js"
import style0 from "./DecisionList.vue?vue&type=style&index=0&id=73e27873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e27873",
  null
  
)

export default component.exports